import React from "react";
import "./index.scss";
import develop1 from "../../../assets/images/aboutUs/develop1.png";
function Develop() {
  return (
    <div className="develop_" id="develop_id">
      <div className="develop_edition">
        <div className="edition_solution edition_solution_top">
          <div className="edition_solution_title">
            <div>发展历程</div>
            <span></span>
          </div>
        </div>
        <div className="develop_con">
          <div className="develop_con_bg">
            <img src={develop1} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Develop;
